import {PlayerDurum} from '@/plugins/uyap-plugin/store/modules/GorevYoneticisiTypes';

/**
 * İşlemler ekranındaki Başlat/Durdur düğmesi görünür mü? (DEV-2603, C6)
 *
 * UYAP bağlantısı yalnız BAŞLATMAK için gerekir: bağlantı yokken 'Başlat'ın bir işlevi yok.
 * Ama bot UYAP düşse de 'oto'da kalır (dongu artık player'ı 'dur' yapmıyor; botBaglantisiniSurdur
 * geri çekilmeyle yeniden girmeyi dener). Kullanıcı o bekleme sırasında botu durdurabilmeli;
 * 'durduruluyor' da görünür kalır ki düğme basıldığı anda yok olmasın, ilerleme çarkı görünsün.
 *
 * NOT: PlayerDurum.oto sayısal 0'dır; karşılaştırma her zaman açık yapılır (falsy tuzağı).
 */
export function baslatDurdurDugmesiGorunurMu(playerDurum: PlayerDurum, uyapBagli: boolean): boolean {
    return uyapBagli || playerDurum !== PlayerDurum.dur;
}
